























import { Component, Vue } from 'vue-property-decorator';

import RepositoryFactory from '@/repository/RepositoryFactory';

import * as DesignCode from '@/classification/DesignCode';

import GDPRconfirm from '@/components/GDPRconfirm.vue';

@Component(
  {
    components: {
      'e-gdpr-confirm': GDPRconfirm,
    },
  },
)
export default class ExamFooter extends Vue {
  private copyright = '';

  private inquiryUrl = '';

  private privacyPolicyUrl = 'https://my.cybird.ne.jp/sp-inq/agreement';

  get paths() {
    return this.$store.state.routerPath;
  }

  get storedExam() {
    return this.$store.state.exam;
  }

  private mounted() {
    // コピーライト取得 問い合わせURL取得
    if (this.storedExam !== null && this.storedExam.resources !== undefined) {
      this.bindResources(this.storedExam.resources);
    } else {
      const ExamRepository = RepositoryFactory.get().exam;
      ExamRepository.getExam().then((response) => {
        if (response.status === 200 && response.data.resources !== undefined) {
          this.bindResources(response.data.resources);
        }
      });
    }
  }

  /**
   * リソースから各値をセット
   */
  private bindResources(resources: any) {
    resources.forEach((resource: any) => {
      if (resource.display_place_key === DesignCode.INQUIRY_URL) {
        this.inquiryUrl = resource.display_text;
      } else if (resource.display_place_key === DesignCode.PRIVACY_POLICY_URL && resource.display_text) {
        this.privacyPolicyUrl = resource.display_text;
      } else if (resource.display_place_key === DesignCode.COPY_RIGHT) {
        this.copyright = resource.display_text;
      }
    });
  }
}
